import { render, staticRenderFns } from "./OTDRPrivacy.vue?vue&type=template&id=688b058e&scoped=true&"
import script from "./OTDRPrivacy.vue?vue&type=script&lang=js&"
export * from "./OTDRPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./OTDRPrivacy.vue?vue&type=style&index=0&id=688b058e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b058e",
  null
  
)

export default component.exports